export const isHallowRedirect = (redirectUrl: string) => {
  try {
    const url = new URL(redirectUrl, window.location.href);
    return url.hostname.endsWith("hallow.com") || url.protocol === "hallow:";
  } catch {
    return false;
  }
};
